import React from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";
import CustomDatePicker from "../../../../../components/Custom-Datepicker";

const AttendanceBookFilter = ({
  formData,
  handleChange,
  handleGetData,
  handleReset,
  filterFormData,
}) => {
  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  console.log("===>filterFormData", filterFormData);

  const customStyle = {
    control: (provided) => ({
      ...provided,
      height: "70px",
      overflow: "scroll",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#22ACD3",
        color: "white",
      },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: "0px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      width: "28px",
      height: "34px",
      marginTop: "9px",
    }),
  };

  return (
    <div className="dropdown-menu custom-dropdown-width" aria-labelledby="excel-btn">
      <div className="container">
        <div className="row">
          <form onClick={stopPropagation}>
            <div className="row">
              {formData?.map((ele, index) => (
                <div className="col-md-4 mt-1" key={index}>
                  <Form.Group>
                    {ele?.type !== "Checkbox" && (
                      <Form.Label className="mb-0">{ele?.name}</Form.Label>
                    )}
                    {ele?.type === "Select" ? (
                      <Select
                        options={ele?.options}
                        isDisabled={ele?.visible || false}
                        value={ele?.options?.find(
                          (option) =>
                            option.value ===
                            filterFormData?.find((item) => item.label === ele?.name)?.value
                        )|| null}
                        name={ele?.name}
                        placeholder={ele?.placeholderText || ele?.name}
                        onChange={(e) => handleChange(e, ele?.name)}
                      />
                    ) : ele?.type === "Date" ? (
                      <CustomDatePicker
                        handleChange={(e) => handleChange(e.target.value, ele?.name)}
                        showYearDropdown
                        dropdownMode="select"
                        name={ele?.name}
                        id={`datepicker-${ele?.name}`}
                        className="form-control"
                        placeholderText="DD-MM-YYYY"
                        value={
                          filterFormData?.find((o) => o.label === ele?.name)?.value || null
                        }
                      />
                    ) : ele?.type === "Text" ? (
                      <Form.Control
                        type="text"
                        name={ele?.name}
                        onChange={(e) => handleChange(e.target.value, ele?.name)}
                        value={filterFormData?.find((o) => o.label === ele?.name)?.value || ""}
                      />
                    ) : ele?.type === "Number" ? (
                      <Form.Control
                        type="number"
                        name={ele?.name}
                        onChange={(e) => handleChange(e.target.value, ele?.name)}
                        value={filterFormData?.find((o) => o.label === ele?.name)?.value || ""}
                      />
                    ) : ele?.type === "IsMulti" ? (
                      <Select
                        options={ele?.options}
                        value={ele?.options?.filter((option) =>
                          filterFormData
                            ?.find((item) => item.label === ele?.name)
                            ?.value?.includes(option.value)
                        )}
                        name={ele?.name}
                        placeholder={ele?.placeholderText || ele?.name}
                        isMulti
                        onChange={(selectedOptions) =>
                          handleChange(
                            selectedOptions.map((option) => option.value),
                            ele?.name
                          )
                        }
                        styles={customStyle}
                      />
                    ) : ele?.type === "Checkbox" ? (
                      <Form.Check
                      className="mt-4"
                        type="checkbox"
                        id={`checkbox-${ele?.name}`}
                        label={ele?.name}
                        checked={
                          filterFormData?.find((item) => item.label === ele?.name)?.value || false
                        }
                        onChange={(e) => handleChange(e.target.checked, ele?.name)}
                      />
                    ) : null}
                  </Form.Group>
                </div>
              ))}
            </div>
          </form>

          <div className="row mt-4">
            <div className="text-end">
              <button className="custom-btn me-2" onClick={(e) => {
    e.preventDefault();
    e.stopPropagation();
    handleReset();
  }} type="button">
               Reset
              </button>
              <button className="custom-btn" onClick={() => handleGetData()} type="button">
                Get Data
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceBookFilter;